const _ = {
    find: require('lodash/find'),
    findIndex: require('lodash/findIndex'),
    forEach: require('lodash/forEach'),
    sortBy: require('lodash/sortBy'),
};
import React from 'react';
import PropTypes from 'prop-types';
const Moment = require('moment');

const Globals =         require('../../../../app/globals');
const Strings =         require('../../../../app/shared/Strings');
const StringUtil =      require('../../../../app/shared/StringUtil');
const ShortCourseUtil = require('../../../../app/shared/ShortCourseUtil');

import SortableTable2 from '../table/SortableTable2';
import ExpansionButton from '../common/ExpansionButton';

const propTypes = {
    doc: PropTypes.object.isRequired,
    students: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        display_name: PropTypes.string,
        email: PropTypes.string,
    })),
    getStatusForStudent: PropTypes.func.isRequired,
    getStartTimeForStudent: PropTypes.func.isRequired,
    getCompleteTimeForStudent: PropTypes.func.isRequired,
    getTimePlayedForStudent: PropTypes.func.isRequired,
    resetStudentAttempts: PropTypes.func,
    mastery_score: PropTypes.number.isRequired,
    studentViewer: PropTypes.number,
};

const defaultProps = {
    students: []
};

class StudentReportTableShortCourse extends React.Component {
    constructor(props) {
        super(props);
        const rows = this.rowsInstantiator(props.students);        
        this.state = {
            rows,
            node_expanded: {},
        };
    }

    componentDidUpdate(prevProps) {
        // re-instatiate rows table on props update. primarily used for adding students operation
        if (prevProps.students.length !== this.props.students.length) {
            this.setState({ rows: this.rowsInstantiator(this.props.students) });
        }
    }

    rowsInstantiator = (students) => {
        // instantiate row values so sort works
        return students.map((row)=>{
            let {status, displayName} = this.props.getStatusForStudent(row.id)
            return {
                ...row,
                email: row.email || row.third_party_email,
                status,
                statusDisplayName: displayName,
                start_time: this.props.getStartTimeForStudent(row.id),
                complete_time:  this.props.getCompleteTimeForStudent(row.id),
                time_played: StringUtil.getTimeStringForMs(this.props.getTimePlayedForStudent(row.id)),
                reset_attempts: row.id,
                expanded: false,
            }});
    }

    canResetAttempt=(id)=>{
        if (!this.props.resetStudentAttempts) {
            return false;
        }
        let element = _.find(this.state.rows,{id});
        if (element) {
            switch(element.status) {
                case Globals.attempt.user_statuses.NEW: // nothing to reset
                case Globals.attempt.user_statuses.COMPLETE: // too late to reset
                    return false;
                case Globals.attempt.user_statuses.IN_PROGRESS:
                    return true;
            }
        }
    }
    
    static calculateAggregates(doc) {
        let student_aggregates = {};
        _.forEach(doc.content_blocks, (cb) => {
            const isBot = (cb.type === Globals.short_course.content_block_type.CHATBOT);
            _.forEach(cb.content_block_instances, (cbi) => {
                _.forEach(cbi.users_to_attempts, (u2att) => {
                    let attempt;
                    if (isBot) {
                        let {bot_id,attempt:attemptNumber} = u2att;
                        attempt = _.find(cbi.attempts,{bot_id,attempt:attemptNumber});
                        attempt = {
                            ...attempt, status_date: u2att.created_at, // fill in expected data
                        };
                    }
                    else {
                        attempt = _.find(cbi.attempts,{id: u2att.content_attempt_id});
                    }
                    if (!attempt) {
                        console.log("calculateAggregates error - didn't find attempt for u2att:",u2att); // debug this if it happens
                        return;
                    }
                    const studentId = Number(u2att.user_id);
                    const start_time = new Date(attempt.created_at);
                    let last_time;
                    if (u2att.user_status_token === Globals.attempt.user_statuses.COMPLETE) {
                        last_time = new Date(attempt.status_date);
                    }
                    let xd = student_aggregates[studentId];
                    if (!xd) {
                        let courseResult = ShortCourseUtil.getCourseOverallResult(doc, studentId);
                        student_aggregates[studentId] = { start_time, last_time, courseResult, time_played: u2att.time_played };
                    }
                    else {
                        if (start_time < xd.start_time) {
                            xd.start_time = start_time;
                        }
                        if (last_time) {
                            if (!xd.last_time) {
                                xd.last_time = last_time;
                            }
                            else if (last_time > xd.last_time) {
                                xd.last_time = last_time;
                            }
                        }
                        xd.time_played += u2att.time_played;
                    }
                })
            });
        });
        return student_aggregates;
    }
    
    getAttemptsForStudent=(student)=>{
        const doc = this.props.doc;
        let attempts = [];
        _.forEach(doc.content_blocks, (cb) => {
            const isBot = (cb.type === Globals.short_course.content_block_type.CHATBOT);
            let activity_name = `Activity for nova_activity_id ${cb.nova_activity_id}`; // fallback
            let activity_meta_type = '';
            if (isBot) {
                activity_name = cb.display_title;
            }
            else if (cb && cb.activity) {
                if (cb.activity.meta_data && cb.activity.meta_data) {
                    let m = cb.activity.meta_data;
                    if (m.display_name) {
                        activity_name = m.display_name;
                    }
                    else if (m.title) {
                        activity_name = m.title;
                    }
                }
                activity_meta_type = cb.activity.meta_type;
            }
            _.forEach(cb.content_block_instances, (cbi) => {
                const isBot = (cb.type === Globals.short_course.content_block_type.CHATBOT);
                const node_id = cbi.node_id;
                let node = _.find(doc.nodes,{node_id});
                let node_name = node ? node.name : '';
                _.forEach(cbi.users_to_attempts, (u2att) => {
                    let attempt;
                    if (isBot) {
                        let {bot_id,attempt:attemptNumber} = u2att;
                        attempt = _.find(cbi.attempts,{bot_id,attempt:attemptNumber});
                    }
                    else {
                        attempt = _.find(cbi.attempts,{id: u2att.content_attempt_id});
                    }
                    if (student.id == u2att.user_id) {
                        let scoreData,score;
                        if (isBot) {
                            attempt = {...attempt, status_date: u2att.created_at };
                            // id: attempt.id,
                            // status_date: new Date(attempt.status_date),
                        }
                        else {
                            if (!cbi.sc_analytics || !cbi.sc_analytics.scoreCategoryTotalsByUser) {
                                // console.log(`missing sc_analytics scoreCategoryTotalsByUser for cbi`,cbi);
                                return;
                            }
                            score = u2att.status_score;
                            scoreData = { score, score_categories: [] };
                            const userEntry = cbi.sc_analytics.scoreCategoryTotalsByUser[student.hash];
                            if (!userEntry) {
                                // console.log(`cbi without userEntry for ${student.hash}\n${JSON.stringify(cbi)}`);
                                return;
                            }
                            const attemptEntry = userEntry[attempt.nova_act_inst_id];
                            if (!attemptEntry) {
                                // console.log(`userEntry without attemptEntry for ${student.hash} ${attempt.nova_act_inst_id}`, cbi);
                                return;
                            }
                            _.forEach(attemptEntry,(sc,entry_key)=>{
                                if (typeof sc.sc_name === 'undefined') {
                                    if (entry_key !== 'flags') {
                                        console.log("unexpected scoreCategoryTotalsByUser entry",sc,entry_key);
                                    }
                                    return;
                                }
                                const name = sc.sc_name; // aka category_id
                                let display_name;
                                if (cbi.sc_analytics.scoreCategories) {
                                    const cat = _.find(cbi.sc_analytics.scoreCategories,{name});
                                    if (cat) {
                                        display_name = cat.display_name;
                                    }
                                }
                                scoreData.score_categories.push({
                                    category_id: name,
                                    display_name, 
                                    score: sc.score,
                                    max_score: sc.max_score,
                                });
                            });
                        }
                        // console.log("scoreData",scoreData);
                        let skillsInvolved = [];
                        let tutorial_score = doc.tutorial_score_a2 || 45;
                        _.forEach(cb.subskill_relations,(xref,hash)=>{
                            let ss = _.find(doc.subskills,{hash});
                            if (ss && ss.node_relations[node_id]) {
                                const nr = cb.node_relations[node_id]; // ss.node_relations[node_id];
                                let activity_type = nr ? nr.activity_type : cb.activity_type;
                                let activityTypeObj = _.find(doc.activity_types,{id:activity_type});
                                if (activityTypeObj && activityTypeObj.gate > 2) {
                                    tutorial_score = doc.tutorial_score_a3;
                                }
                                
                                let user_subskill_state = ss.node_relations[node_id].subskill_states[student.id];
                                if (user_subskill_state) {
                                    let subskill_score;
                                    if (isBot) {
                                        let ss = _.find(u2att.subskillImpacts,{subskill_hash: hash});
                                        subskill_score = ss && ss.score;
                                    }
                                    else {
                                        if (xref.cb_score_type === Globals.short_course.content_block_score_req_type.OVERALL) {
                                            subskill_score = scoreData.score;
                                        }
                                        else {
                                            let cat = _.find(scoreData.score_categories,{category_id: xref.objective_name});
                                            if (cat) {
                                                subskill_score = (cat.score * 100 / cat.max_score);
                                            }
                                        }
                                    }
                                    let passed_subskill = (subskill_score >= doc.mastery_score);
                                    
                                    skillsInvolved.push({
                                        subskill: ss,
                                        score: subskill_score,
                                        passed: passed_subskill
                                    });
                                    
                                }
                            }
                        }); // for subskill_relations
                        
                        const reviewUrl = isBot ? '' : `${cb.activity.template.template_url}/review/web/${attempt.nova_act_inst_id}/${student.hash}`;
                        
                        attempts.push({
                            id: attempt.id || `row${attempts.length}`,
                            cb_hash: cb.hash,
                            node_id,
                            node_name,
                            activity_name,
                            activity_meta_type,
                            time_played: u2att.time_played,
                            created_at: new Date(attempt.created_at),
                            status_date: new Date(attempt.status_date),
                            status_token: u2att.user_status_token,
                            skillsInvolved,
                            reviewUrl,
                            tutorial_score,
                        });
                        //console.log("timestamp",timestamp);
                        //console.log("status",u2att.user_status_token);
                    }
                }); // for users_to_attempts
            });
        });
        return attempts;
    }
    
    toggleExpanded=(id)=>{
        let rows = this.state.rows.slice();
        let i = _.findIndex(rows,{id});
        if (i >= 0) {
            rows[i].expanded = !rows[i].expanded;
            this.setState({rows});
        }
    }
    
    isNodeExpanded=(studentId,node_id)=>{
        let stu_x = this.state.node_expanded[studentId];
        if (!stu_x) {
            return this.props.studentViewer ? true : false; // expand nodes by default for student viewing their own progress 
        }
        return stu_x[node_id] ? true : false;
    }
    
    toggleNodeExpanded=(studentId,node_id)=>{
        let expanded = this.isNodeExpanded(studentId,node_id);
        let node_expanded = {...this.state.node_expanded};
        let stu_x = node_expanded[studentId] || {};
        stu_x[node_id] = expanded ? false: true;
        node_expanded[studentId] = stu_x;
        this.setState({node_expanded});
    }
    
    renderNodeAttemptsTable=(attempts,node_id)=>{
        let attempt_rows = [];
        let subskill_headings = {};
        _.forEach(attempts,(entry)=>{
            if (entry.node_id == node_id) {
                let r = {
                    id: entry.id,
                    activity_name: entry.activity_name,
                    activity_meta_type: entry.activity_meta_type,
                    time_played: StringUtil.getTimeStringForMs(entry.time_played),
                    status_date: Moment(entry.status_date).format('YYYY-MM-DD, h:mm:ss a'),
                    status_token: entry.status_token,
                };
                _.forEach(entry.skillsInvolved,(si)=>{
                    r[si.subskill.hash] = Math.round(si.score);
                    subskill_headings[si.subskill.hash] = si.subskill.display_name;
                });

                attempt_rows.push(r);
            }
        });
        // make sure there are no undefined scores
        _.forEach(attempt_rows,(entry)=>{
            _.forEach(subskill_headings,(name,hash)=>{
                if (typeof entry[hash] === 'undefined') {
                    entry.hash = '';
                }
            });
        });
        
        let activityNameWidth = this.props.activityNameWidth || '70rem'
        let displayColumnCallbacks = {
            'activity_name': (activity_name, id) => {
                let attempt = _.find(attempts,{id});
                if (attempt && attempt.reviewUrl) {
                    return (
                        <span style={{width:activityNameWidth}} title="review activity">
                            <a href={attempt.reviewUrl} target='_blank'>
                                {activity_name}
                            </a>
                        </span>
                    )
                }
                return (
                    <span style={{width:activityNameWidth}}>
                        {activity_name}
                    </span>
                );
            },
        };
        
        
        let columns = [
            {
                displayName: "Activity",
                key: 'activity_name',
                type: 'string',
                width: activityNameWidth,
            },
            {
                displayName: "Meta Type",
                key: 'activity_meta_type',
                type: 'string',
            },
            {
                displayName: "Last Update",
                key: 'status_date',
                type: 'date',
                width: '20rem',
            },
        ];
        
        let mastery_score = this.props.mastery_score;
        
        _.forEach(subskill_headings,(name,hash)=>{
            columns.push({
                displayName: name,
                key: hash,
                type: 'string',
            });
            displayColumnCallbacks[hash] = (score,id)=>{
                let attempt = _.find(attempts,{id});
                if (!attempt) {
                    console.log("displayColumnCallbacks did not find attempt",id); // FIXME: remove debug spam
                }
                let tutorial_score = attempt ? attempt.tutorial_score : 45;
                let scoreClass;
                if (score >= mastery_score) {
                    scoreClass = "short-course-score passing-color";
                }
                else if (score >= tutorial_score) {
                    scoreClass = "short-course-score practice-color";
                }
                else {
                    scoreClass = "short-course-score tutorial-color";
                }
                return (
                    <span className={scoreClass}>
                        {score}
                    </span>
                );
            }
        });
        columns = columns.concat([
            {
                displayName: 'Status',
                key: 'status_token',
                type: 'string',
                width: '12rem',
            },
            {
                displayName: 'Time Played',
                key: 'time_played',
                type: 'string'
            },
        ]);
        
        
        return (
            <div className="short-course-student-nodes-table">
                <SortableTable2
                    classNameTable="margin-bottom-15 font-size-md"
                    showTotal={false}
                    hideSearch
                    rows={attempt_rows}
                    uniqueRowKey="id"
                    defaultSort={{ key:'status_date', type:'date', asc: true }}
                    columns={columns}
                    displayColumnCallbacks={displayColumnCallbacks}
                    
                />
            </div>
        );
        
    } // renderNodeAttemptsTable
    
    renderStudentShortCourseAttemptsTable=(id)=>{
        const row = _.find(this.state.rows,{id});
        if (!row) {
            return null;
        }
        const student = _.find(this.props.students,{id});
        const unsorted_attempts = this.getAttemptsForStudent(student);
        let attempts =_.sortBy(unsorted_attempts,['node_id','status_date']);
        let node_rows = [];
        let last_node_id,node_attempts,created_at;
        let last_entry,last_push_id;
        _.forEach(attempts,(entry)=>{
            if (entry.node_id !== last_node_id) {
                if (last_node_id) {
                    last_push_id = entry.node_id;
                    node_rows.push({
                        expanded: this.isNodeExpanded(student.id,entry.node_id),
                        created_at: Moment(entry.created_at).format('YYYY-MM-DD, h:mm:ss a'),
                        node_id: entry.node_id,
                        node_name: entry.node_name, 
                        node_attempts
                    });
                }
                last_node_id = entry.node_id;
                created_at = entry.created_at;
                node_attempts = 1;
            }
            else {
                node_attempts++;
            }
        });
        let entry = attempts[attempts.length-1];
        if (entry && (entry.node_id !== last_push_id)) {
            node_rows.push({
                expanded: this.isNodeExpanded(student.id,entry.node_id),
                created_at: Moment(entry.created_at).format('YYYY-MM-DD, h:mm:ss a'),
                node_id: entry.node_id,
                node_name: entry.node_name, 
                node_attempts
            });
        }

        return (
            <div className="short-course-student-nodes-table">
                <SortableTable2
                    classNameTable="margin-bottom-15 font-size-md"
                    showTotal={false}
                    hideSearch
                    rows={node_rows}
                    uniqueRowKey="node_id"
                    defaultSort={{ key:'index', type:'number', asc: true }}
                    columns={[
                        {
                            displayName: '',
                            key: 'expanded',
                            type: 'string',
                            width: '3rem',
                        },
                        {
                            displayName: "Start Time",
                            key: 'created_at',
                            type: 'string',
                            width: '20rem',
                        },
                        {
                            displayName: 'Node',
                            key: 'node_name',
                            type: 'string'
                        },
                        {
                            displayName: 'Attempts',
                            key: 'node_attempts',
                            type: 'string'
                        },
                    ]}
                    displayColumnCallbacks={{
                        'expanded': (expanded, node_id) => {
                            return (
                                <span style={{width:'3rem'}}>
                                    <ExpansionButton
                                        disabled={false}
                                        expanded={expanded}
                                        ariaText="Show Attempts"
                                        onClick={()=>{this.toggleNodeExpanded(student.id,node_id)}}
                                        expandedIcon="fa-caret-square-o-down"
                                        collapsedIcon="fa-caret-square-o-right"
                                    />
                                </span>
                            );
                        },
                    }}
                    rowExtraElements={(node_id) => {
                        if (this.isNodeExpanded(student.id,node_id)) {
                            return this.renderNodeAttemptsTable(attempts,node_id);
                        }
                        return null;
                    }}
                    rowClassName={(node_id) => {
                        if (this.isNodeExpanded(student.id,node_id)) {
                            return 'table-bg-color-expanded';
                        }
                        return '';
                    }}
                />
            </div>
        );
    } // renderStudentShortCourseAttemptsTable
    
    resetAttempts=(id)=>{
        let element = _.find(this.state.rows,{id});
        if (element) {
            if (window.confirm("Clear Activity Attempts for this student? (Analytics will not be altered)")) {
                this.props.resetStudentAttempts(element.hash);
            }
        }
    }

    render() {
        if (this.props.studentViewer) {
            return this.renderStudentShortCourseAttemptsTable(this.props.studentViewer);
        }
        return (
            <div className="short-course-student-report-table">
                <SortableTable2
                    classNameTable="margin-bottom-15 font-size-md"
                    showTotal={false}
                    rows={this.state.rows}
                    uniqueRowKey="id"
                    defaultSort={{ key:'last_name', type:'string', asc: true }}
                    columns={[
                        {
                            displayName: '',
                            key: 'expanded',
                            type: 'string',
                            width: '3rem',
                        },
                        {
                            displayName: Strings['en'].short_course_instance.report_table.TH_FIRST_NAME,
                            key: 'first_name',
                            type: 'string'
                        },
                        {
                            displayName: Strings['en'].short_course_instance.report_table.TH_LAST_NAME,
                            key: 'last_name',
                            type: 'string'
                        },
                        {
                            displayName: Strings['en'].short_course_instance.report_table.TH_EMAIL,
                            key: 'email',
                            type: 'string'
                        },
                        {
                            displayName: Strings['en'].short_course_instance.report_table.TH_STATUS,
                            key: 'statusDisplayName',
                            type: 'id',
                            width: '12rem',
                        },
                        {
                            displayName: Strings['en'].short_course_instance.report_table.TH_START_TIME,
                            key: 'start_time',
                            type: 'string'
                        },
                        {
                            displayName: Strings['en'].short_course_instance.report_table.TH_COMPLETE_TIME,
                            key: 'complete_time',
                            type: 'string'
                        },
                        {
                            displayName: Strings['en'].short_course_instance.report_table.TH_TIME_PLAYED,
                            key: 'time_played',
                            type: 'string'
                        },
                        
                        {
                            displayName: Strings['en'].short_course_instance.report_table.TH_RESET,
                            key: 'reset_attempts',
                            type: 'string'
                        },
                    ]}
                    displayColumnCallbacks={{
                        'expanded': (expanded, id) => {
                            return (
                                <span>
                                    <ExpansionButton
                                        disabled={false}
                                        expanded={expanded}
                                        ariaText="Show Attempts"
                                        onClick={()=>{this.toggleExpanded(id)}}
                                        expandedIcon="fa-caret-square-o-down"
                                        collapsedIcon="fa-caret-square-o-right"
                                    />
                                </span>
                            );
                        },
                        'reset_attempts': (dummy, uniqueRowId) => {
                            return (
                                <span>
                                    { this.canResetAttempt(uniqueRowId) ?
                                    <button className="btn btn-primary reset-attempts-button" onClick={()=>{ this.resetAttempts(uniqueRowId) } }>
                                        {'Reset Attempts'}
                                    </button>
                                    : '' }
                                </span>
                            )
                        },
                    }}
                    rowExtraElements={(id) => {
                        const row = _.find(this.state.rows,{id});
                        if (!row.expanded) {
                            return null;
                        }
                        return this.renderStudentShortCourseAttemptsTable(id);
                    }}
                    rowClassName={(id) => {
                        const row = _.find(this.state.rows,{id});
                        if (!row.expanded) {
                            return '';
                        }
                        return 'table-bg-color-expanded';
                    }}
                />
            </div>
        );
    }
}

StudentReportTableShortCourse.propTypes = propTypes;
StudentReportTableShortCourse.defaultProps = defaultProps;

export default StudentReportTableShortCourse;